import { useLayoutEffect, useRef } from 'react';
import { NavigationType, useLocation, useNavigationType } from 'react-router';

// Opens each new page at the top (LI-7732). POP — back/forward, and the initial
// load — is left to the browser's own scroll restoration.
export const useScrollReset = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const previousPathname = useRef(pathname);

  useLayoutEffect(() => {
    // The effect also re-runs when navigationType alone changes (a query or
    // facet change), so the pathname guard, not the deps, decides.
    if (pathname === previousPathname.current) {
      return;
    }
    previousPathname.current = pathname;

    if (navigationType !== NavigationType.Pop) {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);
};
